import { useMutation, useQuery } from '@apollo/client'
import { ErrorComponent, NotFound, ProgressSpinner } from '@medical/components'
import { clinicalDepartmentNames } from '@medical/libs'
import AcceptedWorkScheduleCancelScene from '@medical/pages/doctor/AcceptedWorkScheduleCancel/AcceptedWorkScheduleCancelScene'
import { DOCTOR_WORK_SCHEDULE } from '@medical/pages/doctor/SingleSchedule/SingleSchedule.graphql'
import { useCustom } from '@medical/provider/context'
import React from 'react'

import { CREATE_WORK_SCHEDULE_CANCELLATION_LETTER } from './AcceptedWorkScheduleDetail.graphql'
import AcceptedWorkScheduleDetailScene from './AcceptedWorkScheduleDetailScene'

const AcceptedWorkScheduleDetail = ({
  closeModal,
  location: { pathname },
  match: {
    url,
    params: { workScheduleId },
  },
}) => {
  const [{ i18n, popup }] = useCustom()
  const { loading, error, data } = useQuery(DOCTOR_WORK_SCHEDULE, {
    variables: { workScheduleId },
  })
  const [createWorkScheduleCancel] = useMutation(
    CREATE_WORK_SCHEDULE_CANCELLATION_LETTER
  )
  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />
  const { workSchedule = {}, departments } = data
  if (!workSchedule) {
    return <NotFound />
  }
  const departmentNames = clinicalDepartmentNames({
    departments,
  })
  const onSubmit = async (
    values,
    { setSubmitting, setFieldValue, resetForm }
  ) => {
    try {
      await createWorkScheduleCancel({
        variables: {
          workScheduleId: values.workScheduleId,
          reason: values.reason,
          reassignDoctorNote: values.reassignDoctorNote,
          // isTickCountCancel: values.isTickCountCancel,
          reworkNote: values.reworkNote,
        },
      })
      if (values.isCheckTime) {
        popup.success(i18n.t('staff.hourlyPayment.submissionSuccess'))
        closeModal()
      }
      setSubmitting(false)
    } catch (error) {
      popup.error(error)
      setSubmitting(false)
      setFieldValue('confirm', false)
    }
  }
  if (
    pathname.indexOf('cancel') > 0 &&
    (workSchedule.workScheduleCancellationLetter === null ||
      workSchedule.workScheduleCancellationLetter?.status === 'REJECTED')
  ) {
    return (
      <React.Fragment>
        <div className='modal-title' style={{ fontWeight: 'bold' }}>
          シフトキャンセル
        </div>
        <p>
          2025年6月時点では、キャンセル回数によるペナルティや減給等は実施いたしておりません。そのため、ドクターサイトのキャンセル申請機能のご活用をお願いいたします。キャンセルにおける運用は現在変更を検討しております。
          <br />
          成約したご勤務について、キャンセルはご遠慮ください。応募承認後時点で、契約が発生いたします。
        </p>
        <AcceptedWorkScheduleCancelScene
          workSchedule={workSchedule}
          i18n={i18n}
          closeModal={closeModal}
          departmentNames={departmentNames}
          onSubmit={onSubmit}
        />
      </React.Fragment>
    )
  }
  return (
    <AcceptedWorkScheduleDetailScene
      workSchedule={workSchedule}
      i18n={i18n}
      closeModal={closeModal}
      departmentNames={departmentNames}
      url={url}
    />
  )
}
export default AcceptedWorkScheduleDetail
